import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RxAuthService } from '../rx-auth/rx-auth.service';



@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  constructor(
    private http: HttpClient,
    private auth: RxAuthService,
  ) {}

  logout(): Observable<any> {

    let url = `${environment.backend_base}main/auth/logout/`;
    return this.http.post(url, {})

  }
}
